var React = require('react');

function IconArrowWideUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M513.7 96.9l191.8 445.4-132.7-58.2-59.1 442.1-63.3-442.1-132.6 58.2z"}));
}

IconArrowWideUp.displayName = "IconArrowWideUp";

IconArrowWideUp.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconArrowWideUp;

IconArrowWideUp.default = IconArrowWideUp;
